import { S as Splide } from "./splide.esm-Cg9MkWOe.js";
import { P as Price } from "./ProductPrice--l97YCzz.js";
import { D, g } from "./preact.module-B5ZnQuyU.js";
import { i as isAuthorized } from "./utils-D8tYCXRD.js";
import "./currency-DRNmrEpZ.js";
class RecentlyViewedCarousel extends HTMLElement {
  constructor() {
    super();
    this.products = [];
  }
  connectedCallback() {
    this.loadRecentlyViewedProducts();
    this.setupEventListeners();
    this.renderCarousel();
  }
  setupEventListeners() {
    document.addEventListener(
      "recentlyViewedUpdated",
      this.renderCarousel.bind(this)
    );
  }
  loadRecentlyViewedProducts() {
    var _a;
    const storedProducts = localStorage.getItem("recentlyViewed");
    if (storedProducts) {
      this.products = JSON.parse(storedProducts);
    }
    const themeVarsProduct = (_a = window.ThemeVars) == null ? void 0 : _a.product;
    if (themeVarsProduct) {
      this.addProduct(themeVarsProduct);
    }
  }
  addProduct(product) {
    if (this.products.some((p) => p.id === product.id)) {
      return;
    }
    this.products.unshift(product);
    this.updateProducts(this.products);
  }
  updateProducts(products) {
    this.products = products;
    localStorage.setItem("recentlyViewed", JSON.stringify(this.products));
    document.dispatchEvent(new CustomEvent("recentlyViewedUpdated"));
  }
  renderCarousel() {
    var _a, _b;
    console.log("this.products: ", this.products);
    if (this.products.length > 3) {
      this.innerHTML = `
        <div class="recently-viewed-carousel__wrapper">
          <div class="splide">
            <div class="splide__track">
              <div class="splide__list">
                ${this.products.map(
        (product) => `
                  <div class="splide__slide">
                    ${this.createProductCard(product).outerHTML}
                  </div>
                `
      ).join("")}
              </div>
            </div>
            ${this.renderCarouselControls()}
          </div>
        </div>
      `;
      this.initializeCarousel();
    } else {
      (_b = (_a = this.closest(".product-carousel")) == null ? void 0 : _a.querySelector(".product-carousel__heading")) == null ? void 0 : _b.remove();
    }
  }
  createProductCard(product) {
    var _a, _b, _c, _d, _e, _f;
    const card = document.createElement("div");
    card.className = "product-card";
    if (!isAuthorized(product, window.themeVars.customer)) {
      card.classList.add("product-card--locked");
    }
    const isSingleVariantOutOfStock = !product.available && ((_a = product.tags) == null ? void 0 : _a.includes("single-variant-out-of-stock"));
    const hasBisEnabled = isSingleVariantOutOfStock && ((_b = product.tags) == null ? void 0 : _b.includes("back-in-stock"));
    if (isSingleVariantOutOfStock) {
      card.classList.add("product-card--single-variant-out-of-stock");
    }
    const priceContainer = document.createElement("div");
    priceContainer.className = "product-card__price";
    let showOptions = true;
    let detailsBtnText = window.themeVars.strings.product.btnDetails;
    let detailsBtnClass = "product-card__details-cta btn btn-transparent btn-small";
    if (product.tags.includes("personalised")) {
      showOptions = false;
      detailsBtnText = window.themeVars.strings.product.btnPersonalise;
      detailsBtnClass = "product-card__details-cta btn btn-black btn-small btn-personalise";
    }
    const liCount = [
      product.abv && 1,
      product.style && 1,
      product.size && String(product.size) !== "0" && 1
    ].filter(Boolean).length;
    let showEfpBadge = true;
    if (product.variants.every((variant) => variant.real_compare_at_price)) {
      showEfpBadge = false;
    }
    product.variants.forEach((variant) => {
      if (variant.bundle_item) {
        variant.bundle_item.description = "";
        variant.bundle_item.content = "";
      }
    });
    D(g(Price, { product }), priceContainer);
    const buttonText = product.preOrder === "true" ? window.themeVars.strings.product.pre_order : window.themeVars.strings.product.btnOptions;
    card.innerHTML = `
      <div class="product-card__content">
        <div class="product-card__images${isSingleVariantOutOfStock ? " product-card__images--out-of-stock" : ""}">
          <div class="product-card__badge-wrapper">
            ${isSingleVariantOutOfStock ? `<span class="product-card__badge badge badge-yellow">${window.themeVars.strings.product.soldOut}</span>` : ""}
            ${product.customBadge !== "no input" && product.customBadge !== void 0 && !isSingleVariantOutOfStock ? `<span class="product-card__badge badge badge-orange">${product.customBadge}</span>` : ""}
            ${product.saleBadge && !isSingleVariantOutOfStock ? `<span class="product-card__badge badge badge-red">${product.saleBadge}</span>` : ""}
          </div>
          <div class="responsive-image product-card__image">
            <img width="315" height="315" src="${(_c = product.images[0]) == null ? void 0 : _c.src}" alt="${product.title}" />
          </div>
          ${product.images.length > 1 ? `
            <div class="responsive-image product-card__image product-card__image--rollover">
              <img width="315" height="315" src="${(_d = product.images[1]) == null ? void 0 : _d.src}" alt="${product.title} rollover" />
            </div>
          ` : ""}
          ${!isAuthorized(product, window.themeVars.customer) ? `
            <div class="product-lock" aria-hidden="true">
              <div class="product-lock__wrapper">
                <div class="product-lock__content">
                  <span aria-hidden="true" dangerouslySetInnerHTML={{ __html: window.themeVars.icons.lock }}></span>
                  <div class="product-lock__text">
                    <p class="product-lock__title">${window.themeVars.strings.product.lockedTitle}</p>
                    <p class="product-lock__desc">
                      <a href="${window.themeVars.strings.product.logInLink}">${window.themeVars.strings.product.logIn}</a>&nbsp;
                      ${window.themeVars.strings.product.lockedText}&nbsp;
                      <a href="${window.themeVars.strings.product.signUpLink}">${window.themeVars.strings.product.signUp}</a>
                    </p>
                  </div>
                </div>
                <div class="product-lock__buttons">
                  <a href="${window.themeVars.strings.product.logInLink}" class="product__log-in btn btn-white btn-white--outline">${window.themeVars.strings.product.logIn}</a>
                  <a href="${window.themeVars.strings.product.signUpLink}" class="product__sign-up btn btn-white btn-white--outline">${window.themeVars.strings.product.signUp}</a>
                </div>
              </div>
            </div>
          ` : ""}
        </div>
        ${product.abv || product.style || product.size && String(product.size) !== "0" ? `
          <div class="product-card__info outside">
            <ul class="
              product-card__info-wrapper
              product-card__info-wrapper--${liCount}-items
            ">
              ${product.abv ? `
                <li class="product-card__info-item">
                  <span class="product-card__info-label">${window.themeVars.strings.product.details.abv}</span>
                  <span class="product-card__info-value">${product.abv}%</span>
                </li>
              ` : ""}
              ${product.style ? `
                <li class="product-card__info-item">
                  <span class="product-card__info-label">${window.themeVars.strings.product.details.style}</span>
                  <span class="product-card__info-value">${product.style}</span>
                </li>
              ` : ""}
              ${product.size && String(product.size) !== "0" ? `
                <li class="product-card__info-item">
                  <span class="product-card__info-label">${window.themeVars.strings.product.details.size}</span>
                  <span class="product-card__info-value">${product.size}</span>
                </li>
              ` : ""}
            </ul>
          </div>
        ` : ""}
        <div class="product-card__details">
          <div class="product-card__wrapper">
            <h3 class="product-card__title heading-4">${product.title}</h3>
            ${product.subtitle ? `<p class="product-card__subtitle text-md-body">${product.subtitle}</p>` : ""}
            ${product.abv || product.style || product.size && String(product.size) !== "0" && String(product.size) !== "no input" ? `
              <div class="product-card__info inside">
                <ul class="
                  product-card__info-wrapper
                  product-card__info-wrapper--${liCount}-items
                ">
                  ${product.abv ? `
                    <li class="product-card__info-item">
                      <span class="product-card__info-label">${window.themeVars.strings.product.details.abv}</span>
                      <span class="product-card__info-value">${product.abv}%</span>
                    </li>
                  ` : ""}
                  ${product.style ? `
                    <li class="product-card__info-item">
                      <span class="product-card__info-label">${window.themeVars.strings.product.details.style}</span>
                      <span class="product-card__info-value">${product.style}</span>
                    </li>
                  ` : ""}
                  ${product.size && String(product.size) !== "0" ? `
                    <li class="product-card__info-item">
                      <span class="product-card__info-label">${window.themeVars.strings.product.details.size}</span>
                      <span class="product-card__info-value">${product.size}</span>
                    </li>
                  ` : ""}
                </ul>
              </div>
            ` : ""}
            ${window.themeVars.customer.staff && showEfpBadge ? `
              <p class="product-card__staff-member-badge staff-member-badge">
                <span>${window.themeVars.icons.checkmark}</span>
                ${window.themeVars.strings.product.staffDiscount}
              </p>
              ` : window.themeVars.customer.efpMember && showEfpBadge ? `
              <p class="product-card__efp-member-badge efp-member-badge">
                <span>${window.themeVars.icons.checkmark}</span>
                ${window.themeVars.strings.product.efpDiscount}
              </p>
              ` : ""}

            ${product.hidePricePlp !== "true" ? `<p class="product-card__price-container"></p>` : ""}
            

          </div>
        </div>
         <div class="product-card__buttons">
            ${product.stockistButtonLink && product.stockistButtonText ? `<a
                href="${product.stockistButtonLink}"
                class="product-card__options-cta btn btn-black btn-small"
              >
                ${product.stockistButtonText}
              </a>` : `${showOptions && !isSingleVariantOutOfStock ? `
               <uwp-quickshop-button data-product='${JSON.stringify(product)}'>
                <button
                  aria-label="${window.themeVars.strings.product.quickshopLabel}${product.title}"
                  data-quickshop="${product.handle}"
                  class="product-card__options-cta btn btn-black btn-small"
                >
                  ${buttonText}
                </button>
              </uwp-quickshop-button>` : isSingleVariantOutOfStock && hasBisEnabled ? `<button type="button" class="product-card__options-cta btn btn-black btn-small" data-bis-trigger data-product="${product.id}" data-variant="${(_e = product.variants[0]) == null ? void 0 : _e.id}"><span>${window.themeVars.strings.product.notifyMe}</span></button>` : ""}         `}
            <a href="${window.Shopify.routes.root}products/${product.handle}" class="${detailsBtnClass}" aria-label="${window.themeVars.strings.product.linkLabel}${product.title}">${detailsBtnText}</a>
          </div>

          ${hasBisEnabled ? `<uwp-product-notify-me data-product-id="${product.id}" data-variant-id="" product-data='${JSON.stringify(product)}' is-visible="false"></uwp-product-notify-me>` : ""}
      </div>
    `;
    (_f = card.querySelector(".product-card__price-container")) == null ? void 0 : _f.appendChild(priceContainer);
    if (hasBisEnabled) {
      setTimeout(() => {
        const bisButton = card.querySelector(
          `[data-bis-trigger][data-product="${product.id}"]`
        );
        const bisPopup = card.querySelector(
          `uwp-product-notify-me[data-product-id="${product.id}"]`
        );
        if (bisButton && bisPopup) {
          const handleBisClick = () => {
            bisPopup.setAttribute("is-visible", "true");
          };
          bisButton.addEventListener("click", handleBisClick);
        }
      }, 100);
    }
    return card;
  }
  renderCarouselControls() {
    return `
    <div class="carousel-controls">
      <div class="carousel-controls__scrollbar-track">
        <div class="carousel-controls__scrollbar-progress" js-carousel-controls="scrollbarProgress"></div>
      </div>
      <div class="carousel-controls__arrow-wrapper splide__arrows splide__arrows--ltr">
        <button class="splide__arrow carousel-controls__arrow splide__arrow--prev" type="button" aria-label="Previous">
          ${window.themeVars.icons.chevronLeft}
        </button>
        <button class="splide__arrow carousel-controls__arrow splide__arrow--next" type="button" aria-label="Next">
          ${window.themeVars.icons.chevronRight}
        </button>
      </div>
    </div>
    `;
  }
  initializeCarousel() {
    const splideElement = this.querySelector(".splide");
    if (splideElement) {
      const splide = new Splide(splideElement, {
        type: "loop",
        perPage: 3,
        perMove: 1,
        pagination: true,
        padding: {
          right: "10%"
        },
        gap: 16,
        arrows: true,
        breakpoints: {
          640: {
            perPage: 1,
            padding: {
              right: "20%"
            }
          }
        }
      }).mount();
      const scrollBar = this.querySelector(
        "[js-carousel-controls='scrollbarProgress']"
      );
      if (scrollBar) {
        splide.on("mounted move", () => {
          const end = splide.Components.Controller.getEnd() + 1;
          const rate = Math.min((splide.index + 1) / end, 1);
          scrollBar.style.width = String(100 * rate) + "%";
        });
      }
    } else {
      console.error("Splide element not found");
    }
  }
}
customElements.define("uwp-recently-viewed-carousel", RecentlyViewedCarousel);
